import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type SetCompanyAddressRequest as SchemaSetCompanyAddressRequest } from '../schemas/SetCompanyAddressRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Company
 */
export const SetCompanyAddressContentType = 'application/json' as const;
export type SetCompanyAddressRequest = SchemaSetCompanyAddressRequest;
export type SetCompanyAddressResponses = LinkCommonErrorResponses & {};
export type SetCompanyAddressResponseSuccess = undefined;
export type SetCompanyAddressSearchParams = undefined;
export type SetCompanyAddressPathParameters = undefined;
export const SetCompanyAddressUrl = '/company/address' as const;
export const SetCompanyAddressMethod = 'POST' as const;
export const getSetCompanyAddressUrl = (_params?: SetCompanyAddressPathParameters) => SetCompanyAddressUrl;
